import { FunnelIcon } from '@phosphor-icons/react'
import type { NodeProps } from '@xyflow/react'
import { useListCopy } from 'app/hooks/useListCopy'
import { conditionGroupText } from 'app/lib/workflows/conditions'
import { labelForToken } from 'app/lib/workflows/dataContext'
import type { FilterFlowNode } from 'app/types/workflows'
import { NodeShell } from './NodeShell'

/** Single-path gate: only entities matching the conditions continue; the rest leave the workflow. */
export function FilterNode({ data, selected }: NodeProps<FilterFlowNode>) {
  const copy = useListCopy()
  return (
    <NodeShell
      icon={FunnelIcon}
      accent="violet"
      kind="Filter"
      label={data.label}
      // See BranchNode: labelForToken doubles as a by-key label resolver for bare field keys.
      description={conditionGroupText(data, (key) => (key ? labelForToken(key, copy) : undefined))}
      selected={selected}
    />
  )
}
